import React from 'react';
import { Button, Grid2, Link, Typography } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import logo from '../../images/logo.svg';
import { UserCircleIcon } from '@konecorp/ui-library';
import { useLocation, useNavigate } from 'react-router-dom';

interface HeaderProps {
  userName: string | undefined;
  version: string
}

const Header: React.FC<HeaderProps> = ({ version, userName }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div style={{ flexGrow: 1 }}>
      <Grid2
        container
        spacing={2}
        sx={{ width: '100%', padding: '16px 8px 4px 8px' }}
      >
        <Grid2 size="grow">
          <div style={{ display: 'flex' }}>
            <img src={logo} alt="koneLogo" />
            <Typography
              variant="h5"
              sx={{ whiteSpace: 'nowrap', marginLeft: '8px' }}
            >
              Form Builder (version {version})
            </Typography>
          </div>
          {(location.pathname === '/edit' ||
            location.pathname === '/create' ||
            location.pathname === '/images') && (
            <Link
              component="button"
              variant="body1"
              onClick={handleBackClick}
              sx={{
                color: '#1976d2',
                marginTop: '8px',
                display: 'block',
              }}
            >
              &#x3c; Back
            </Link>
          )}
        </Grid2>
        <Grid2 size="grow" sx={{ textAlign: 'right' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Button
              color="inherit"
              data-testid="usermenu-button"
              id="usermenu-button"
              onClick={() => {
                console.warn('User menu clicked');
              }}
              startIcon={<UserCircleIcon data-testid="UserCircleIcon" />}
            >
              {userName}
              <KeyboardArrowDownIcon data-testid="KeyboardArrowDownIcon" />
            </Button>
          </div>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default Header;
